/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonAddressSummaryInfo } from './BabylonAddressSummaryInfo';

export type BabylonContractCodeInfo = {
    CODEID: string;
    CRTADDR: BabylonAddressSummaryInfo;
    PRMSSN: BabylonContractCodeInfo.PRMSSN;
    CNTRCTCNT: string;
    CHCKSUM: string;
};

export namespace BabylonContractCodeInfo {

    export enum PRMSSN {
        UNSPECIFIED = 'UNSPECIFIED',
        NOBODY = 'NOBODY',
        EVERYBODY = 'EVERYBODY',
        ANY_OF_ADDRESSES = 'ANY_OF_ADDRESSES',
    }


}

